import React, { Component } from "react";
import classnames from "classnames";
import { observer } from "mobx-react";

import { emptyArrayToUndefined } from "@formant/core/common/emptyArrayToUndefined";
import { toLegacyTagsets } from "@formant/core/common/toLegacyTagsets";
import { IFilter } from "@formant/core/model/IFilter";
import { StreamType } from "@formant/core/model/StreamType";
import { Uuid } from "@formant/core/model/Uuid";
import { HStack } from "@formant/ui/component/common/HStack";

import { metadataStore, observeStore, tagTemplateStore } from "../../../stores";
import { StreamNameSelect } from "../StreamNameSelect";
import { StreamTypeSelect } from "../StreamTypeSelect";
import { DeviceSelect } from "./DeviceSelect";
import { FilterSearch } from "./FilterSearch";
import * as styles from "./index.scss";
import { TagSelect } from "./TagSelect";

export interface IEditFilterProps {
    value: IFilter;
    context?: IFilter;
    hideDevices?: boolean;
    onChange: (value: IFilter) => void;
}

@observer
export class EditFilter extends Component<IEditFilterProps> {
    private tagOptions: string[] = [];

    public render() {
        const { value, hideDevices, onChange } = this.props;
        const context = {
            ...this.props.context,
            start: observeStore.metadataStart.toISOString(),
            end: observeStore.metadataEnd.toISOString(),
        };
        const loading = metadataStore.list(context) === undefined;
        this.tagOptions =
            tagTemplateStore.list("telemetry")?.map(_ => _.tagKey) ||
            this.tagOptions;
        const tagOptions = this.tagOptions;
        return (
            <HStack
                className={classnames(
                    styles["edit-filter"],
                    loading && styles.loading,
                )}
                hAlign="start"
            >
                <HStack hAlign="start" className={styles.filters}>
                    {!hideDevices && (
                        <DeviceSelect
                            value={value.deviceIds || []}
                            filter={value}
                            context={context}
                            className={styles.select}
                            onChange={this.onChangeDeviceIds}
                        />
                    )}
                    <StreamNameSelect
                        streamFilter="telemetry"
                        value={value.names || []}
                        className={styles.select}
                        onChange={this.onChangeNames}
                    />
                    <StreamTypeSelect
                        streamFilter="telemetry"
                        value={value.types || []}
                        className={styles.select}
                        onChange={this.onChangeTypes}
                    />
                    {...tagOptions
                        .sort()
                        .map(key => (
                            <TagSelect
                                key={key}
                                tagKey={key}
                                value={
                                    (toLegacyTagsets(value.tags) || {})[key] ||
                                    []
                                }
                                filter={value}
                                context={context}
                                className={styles.select}
                                onChange={this.onChangeTagValues}
                            />
                        ))}
                </HStack>
                <div className={styles.search}>
                    <FilterSearch
                        filter={value}
                        context={context}
                        className={styles["filter-search"]}
                        onChange={onChange}
                    />
                </div>
            </HStack>
        );
    }

    private onChangeDeviceIds = (deviceIds: Uuid[]) => {
        this.props.onChange({
            ...this.props.value,
            deviceIds: emptyArrayToUndefined(deviceIds),
        });
    };

    private onChangeNames = (names: string[]) => {
        this.props.onChange({
            ...this.props.value,
            names: emptyArrayToUndefined(names),
        });
    };

    private onChangeTypes = (types: StreamType[]) => {
        this.props.onChange({
            ...this.props.value,
            types: emptyArrayToUndefined(types),
        });
    };

    private onChangeTagValues = (key: string, values: string[]) => {
        const { [key]: ignore, ...tags } =
            toLegacyTagsets(this.props.value.tags) || {};
        this.props.onChange({
            ...this.props.value,
            tags: values.length > 0 ? { ...tags, [key]: values } : tags,
        });
    };
}
